<template>
  <div id="project-image-container"
  class="grid-item"
  v-scroll-reveal>
    <div id="project-image" :style="{backgroundImage: `url(img/thumbs/${$store.state.activeProject.slug}.jpg)`}"></div>
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  }

}

</script>

<style lang="scss" scoped>
  #project-image-container {
    grid-area: image;
    overflow: hidden;
    order: 3;

    @include tablet-below {
      height: 200px;
      margin-bottom: $grid-gap;
    }

    #project-image {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
    }

  }
</style>
